<template>
  <div id="box">
    <dv-full-screen-container>
      <vue-particles v-if="flg" color="#dedede" :particleOpacity="0.7" :particlesNumber="80" shapeType="edge" :particleSize="4" linesColor="#dedede" :linesWidth="1" :lineLinked="true"
                     :lineOpacity="0.5" :linesDistance="150" :moveSpeed="6" :hoverEffect="true" hoverMode="grab" :clickEffect="true" clickMode="push">
      </vue-particles>

      <div class="font-Change">
        <div class="font-chinese" @click="changeChinese()">简体中文</div>
        <div class="font-english" @click="changeEnglish()">English</div>
      </div>
      <div class="box-card">
        <el-card>
          <el-form :model="form" :rules="rules" @keydown.enter.native="onSubmit" class="login-box" label-width="25%" ref="login">
            <div class="title">{{$t("platform")}}</div>
            <el-input prefix-icon="el-icon-s-custom":placeholder= "$t('userName')" v-model="form.email" class="inputEmail"></el-input>
            <el-input prefix-icon="el-icon-lock" :placeholder="$t('password')"  type="password" v-model="form.password" class="inputPwd"></el-input>
            <el-button @click="onSubmit" type="primary" round class="loginBtn" style="position: relative;">{{$t("login")}}</el-button>
          </el-form>
        </el-card>
      </div>
    </dv-full-screen-container>
  </div>
</template>


<script>
  import router from "../router/index"
  import {getAuth, userLogin} from "../untils/api/login";

  export default {
    name: "Login",
    data() {
      return {
        form: {
          email: "",
          password: "",
        },

        // 表单验证，需要在 el-form-item 元素中增加 prop 属性
        rules: {
          email: [
            {required: true, message: this.$t('userError'), trigger: "blur"},
          ],
          password: [
            {required: true, message: this.$t('passwordError'), trigger: "blur"},
          ],
        },
        flg: true,
        windowHeight: 0,
        windowWidth: 0
      };
    },
    mounted() {
      this.windowWidth = document.documentElement.clientWidth;
      if(this.windowWidth <= 500){
        this.flg = false;
      }
      if(localStorage.getItem('locale') === null){
        this.$i18n.locale = 'zh-CN';
        localStorage.setItem('locale', 'zh-CN');
      }
    },
    methods: {
      changeChinese() {
        localStorage.setItem('locale', 'zh-CN');
        window.location.reload();
      },

      changeEnglish() {
        localStorage.setItem('locale', 'en-US');
        window.location.reload();
      },
      /**
       * 登录
       */
      onSubmit() {
        let param = {"username": this.form.email, "password": this.form.password};
        //访问登录api
        userLogin(param).then(response => {
          localStorage.setItem('rainLogin',JSON.stringify(param));
          localStorage.setItem('rainToken',response.token);
          this.getAuthority();
        }).catch(error => {
          console.log("error", error);
          this.$message({
            showClose: true,
            type:'warning',
            message: this.$t('loginError')
          })
        })
      },

      /**
       * 获取用户等级
       */
      getAuthority() {
        getAuth().then(response => {
          localStorage.setItem('authority', response.authority);
          localStorage.setItem('customerId', response.customerId.id);
          localStorage.setItem('email', response.email);
          if (response.authority === 'SYS_ADMIN') {
            this.$message({
              showClose: true,
              type: "warning",
              message: this.$t('loginError')
            });
          } else {
            if(this.windowWidth <= 500){
              router.push({
                name: 'MobileDetailed',
                path: '/MobileDetailed',
                params: {authority: response.authority, customerId: response.customerId.id, email: response.email}
              });
            } else {
              router.push({
                name: 'Home',
                path: '/Home',
                params: {authority: response.authority, customerId: response.customerId.id, email: response.email}
              });
            }
          }
        }).catch(error => {
          this.$message({
            showClose: true,
            type: "warning",
            message: this.$t('loginError')
          });
        })
      },

    },
  };
</script>
<style lang="less">
  @import "less/login.less";
</style>



// WEBPACK FOOTER //
// src/components/Login.vue